var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1136 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-7{fill:#999;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-25,.cls-26,.cls-27,.cls-29,.cls-3,.cls-31,.cls-32,.cls-37,.cls-38,.cls-4,.cls-5,.cls-6,.cls-8{fill-rule:evenodd;}.cls-4{fill:#b3b3b3;}.cls-5{fill:#9e5031;}.cls-6{fill:#804026;}.cls-8,.cls-9{fill:#222c30;}.cls-10{fill:#4d4d4d;}.cls-11{fill:#707070;}.cls-12{fill:#ce8b74;}.cls-13{fill:#b26550;}.cls-14{fill:#332d28;}.cls-15{fill:#edba8a;}.cls-16{fill:#ad7b4c;}.cls-17{fill:#fcdbbd;}.cls-18{fill:#543e2e;}.cls-19{fill:#6e0000;}.cls-20,.cls-24{fill:#900;}.cls-21{fill:#c79256;}.cls-22{fill:#a87841;}.cls-23{fill:#e8b274;}.cls-25{fill:#e6e6e6;}.cls-26{fill:#fff;}.cls-27,.cls-30,.cls-33{fill:#6d5331;}.cls-28,.cls-32{fill:#fbe8ce;}.cls-29,.cls-34{fill:#685d4a;}.cls-31{fill:#efcba5;}.cls-33{opacity:0.1;}.cls-35{fill:#333;opacity:0.8;}.cls-36{fill:#99a5ff;}.cls-37{fill:#eaccac;}.cls-38{fill:#424f54;}.cls-39{fill:#de3232;}.cls-40{fill:#f76161;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 1,
    width: 1136,
    height: 115
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M587.29,15a54.5,54.5,0,0,1,0,109L583.4,69.5,587.29,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M586.86,124s-54.5-24.4-54.5-54.49S557.56,15,586.86,15V124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M626.21,77.28A7.79,7.79,0,1,0,634,85.07a7.79,7.79,0,0,0-7.79-7.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M626.21,81.17a3.9,3.9,0,1,0,3.9,3.9,3.9,3.9,0,0,0-3.9-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M549,77.28a7.79,7.79,0,1,0,7.79,7.79A7.78,7.78,0,0,0,549,77.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M549,81.17a3.9,3.9,0,1,0,3.89,3.9,3.9,3.9,0,0,0-3.89-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M617.23,44.87a38.57,38.57,0,0,1,8.7,24.63v38.92a38.53,38.53,0,1,1-77,0V69.5a38.47,38.47,0,0,1,8.58-24.63,53.57,53.57,0,0,0,29.89,9.06,53.57,53.57,0,0,0,29.88-9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M623.75,66.11a2.19,2.19,0,0,1,4.35,0v42.31c0,22.48-17.23,40.88-41.93,40.88l-2.79-8.76,3-8.76a27,27,0,0,0,16.8-6v16.11c13-6.07,20.61-19.12,20.61-33.52V66.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M586.86,149.3h0s-11.06.87-19.4-4.67c-11.28-7.5-20.75-23.28-20.75-36.21v-41c0-1.08.55-1.95,1.63-1.95s1.63.87,1.63,1.95v41c0,14.4,8.68,26.88,21.7,33V125.83a23.82,23.82,0,0,0,15.19,6h0V149.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M559.2,80.31a2,2,0,1,1,.2-4.06l16.27.81a2,2,0,0,1-.2,4.07l-16.27-.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M601.44,80.45a2,2,0,0,1,.14-4.07l16.28.54a2,2,0,0,1-.14,4.07l-16.28-.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 568.4,
    cy: 88.66,
    r: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 608.43,
    cy: 88.66,
    r: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M591.26,100.5,591,91.05a2.35,2.35,0,0,0-4.7.13h0l.19,7.09-2.37.06a7.08,7.08,0,0,0,.4,14.16l4.72-.14a2.33,2.33,0,0,0,2.28-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M611.82,95.22H596.65c-.86,0-1.11.64-1.11,1.49V99.8c0,2.55,1.66,5.19,4.2,5.19h7.74c2.55,0,4.34-2.64,4.34-5.19V95.22Zm-24.45-3.15a7.65,7.65,0,0,1,5.36,2.11A4.71,4.71,0,0,1,596.65,92h23.2a1.63,1.63,0,0,1,0,3.25h-4.78V99.8a7.32,7.32,0,0,1-7.59,7.36h-7.74A7.6,7.6,0,0,1,592,99.61a4.56,4.56,0,0,0-4.64-4.54l-1.24-1.5,1.24-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M554.88,95.22a1.63,1.63,0,0,1,0-3.25h23.21a4.28,4.28,0,0,1,3.66,2.21,9.2,9.2,0,0,1,5.11-2.11v3.09a4.51,4.51,0,0,0-4.38,4.45,7.39,7.39,0,0,1-7.49,7.55h-7.73a7.26,7.26,0,0,1-7.53-7.36V95.22Zm23.21,0H563V99.8c0,2.55,1.72,5.19,4.27,5.19H575c2.55,0,4.28-2.64,4.28-5.19V96.71c0-.85-.33-1.49-1.18-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M226.6,121.42s-34.36,70.68-45.83,49.29c-2.24-4.17-4.39-95-4.39-99.51C176.38,43.46,199.6,21,226.6,21V121.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M226.48,21c27.73,0,50.74,22.48,50.74,50.22,0,8.09-1.22,97.82-4.62,104.59-8.25,16.44-28-26.5-45.6-54.37L223.41,71.2l3-50.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M262.87,78.37A7.18,7.18,0,1,0,270,85.55a7.17,7.17,0,0,0-7.17-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M262.87,82a3.59,3.59,0,1,0,3.59,3.59A3.59,3.59,0,0,0,262.87,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M191.71,78.37a7.18,7.18,0,1,0,7.18,7.18,7.17,7.17,0,0,0-7.18-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M191.71,82a3.59,3.59,0,1,0,3.59,3.59A3.58,3.58,0,0,0,191.71,82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M254.59,48.5a35.56,35.56,0,0,1,8,22.7v35.87a35.5,35.5,0,1,1-71,0V71.2a35.48,35.48,0,0,1,7.91-22.7,49.59,49.59,0,0,0,55.08,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201,81.42a1.88,1.88,0,0,1,.55-3.71l14.85,2.2a1.88,1.88,0,0,1-.55,3.71L201,81.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239.09,83.52a1.88,1.88,0,0,1,0-3.75l15,0a1.88,1.88,0,0,1,0,3.75l-15,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 209.59,
    cy: 88.85,
    r: 4.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 246.48,
    cy: 88.85,
    r: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M230.66,99.77l-.24-8.7a2.17,2.17,0,0,0-4.34.12h0l.18,6.52-2.18.06a6.53,6.53,0,0,0,.36,13l4.35-.13a2.17,2.17,0,0,0,2.11-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M257,91.91H235.62A4.34,4.34,0,0,0,232,94a7,7,0,0,0-4.94-2h-.47a8.44,8.44,0,0,0-4.71,2,3.94,3.94,0,0,0-3.38-2H197.13a1.5,1.5,0,0,0,0,3h4.47v4.22a6.69,6.69,0,0,0,6.94,6.78h7.12a6.8,6.8,0,0,0,6.9-7,4.16,4.16,0,0,1,4-4.1l.47-.09A4.21,4.21,0,0,1,231.35,99a7,7,0,0,0,7.12,7h7.13a6.75,6.75,0,0,0,7-6.78V94.91H257a1.5,1.5,0,0,0,0-3ZM219.6,99.13c0,2.35-1.59,4.78-3.94,4.78h-7.12c-2.35,0-3.94-2.43-3.94-4.78V94.91h13.91c.79,0,1.09.58,1.09,1.37Zm30,0c0,2.35-1.65,4.78-4,4.78h-7.13c-2.34,0-3.87-2.43-3.87-4.78V96.28c0-.79.23-1.37,1-1.37h14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 244.85,
    cy: 111.04,
    r: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1010.21,106.93V74c0-25.91,21.42-46.91,47.32-46.91s47.32,21,47.32,46.91h0v32.89l-94.64,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1097.13,79.56a7.82,7.82,0,1,0,7.82,7.82,7.82,7.82,0,0,0-7.82-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1097.13,83.47a3.91,3.91,0,1,0,3.91,3.91,3.9,3.9,0,0,0-3.91-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1019,79.56a7.82,7.82,0,1,0,7.82,7.82,7.82,7.82,0,0,0-7.82-7.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1019,83.47a3.91,3.91,0,1,0,3.91,3.91,3.9,3.9,0,0,0-3.91-3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1096.25,71.34v35.57a38.72,38.72,0,1,1-77.44,0V71.34s12.57-15.75,37.48-15.75a58.69,58.69,0,0,1,40,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1023.34,93c0,14.51-3.82,26.28-8.53,26.28s-14.94-11.52-14.94-26,10.24-26.53,14.94-26.53S1023.34,78.46,1023.34,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1091.53,93c0,14.51,3.82,26.28,8.53,26.28s14.94-11.52,14.94-26-10.24-26.53-14.94-26.53S1091.53,78.46,1091.53,93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1045.22,82.19a1.1,1.1,0,0,1-1.44,1.65,5.49,5.49,0,0,0-8.11,1,1.09,1.09,0,1,1-1.79-1.25,7.65,7.65,0,0,1,11.34-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1079.57,83.75a1.09,1.09,0,1,1-1.82,1.19,5.5,5.5,0,0,0-8.08-1.24,1.09,1.09,0,1,1-1.39-1.69,7.65,7.65,0,0,1,11.29,1.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1040.65,87.29a3.24,3.24,0,1,1-3.24,3.24,3.25,3.25,0,0,1,3.24-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1073.09,87.29a3.24,3.24,0,1,1-3.25,3.24,3.24,3.24,0,0,1,3.25-3.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1059.56,101.15l-.07-6.84a1.71,1.71,0,0,0-3.41,0h0l.06,5.14-1.72,0a5.13,5.13,0,0,0,.11,10.26l3.42-.05a1.71,1.71,0,0,0,1.69-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M20.94,142.13l45.64-.74L65.64,84l-45.93.75L20.25,118c.11,6.48-4.91,12.18-11.39,12.28a12.18,12.18,0,0,0,12.08,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M67.81,140.22h0l-.25-25.44C41.72,115,19.75,94.24,19.49,68.3A46.77,46.77,0,1,1,113,67.37l.16,15.68-45.94.46.56,56.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M113.47,140.47l-45.65.46-.57-57.42,45.94-.46.33,33.23c.06,6.48,5.23,12.05,11.71,12a12.17,12.17,0,0,1-11.76,12.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M105,75.28A7.83,7.83,0,1,0,112.9,83,7.81,7.81,0,0,0,105,75.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M105,79.19a3.92,3.92,0,1,0,4,3.88,3.92,3.92,0,0,0-4-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M26.74,76.06a7.83,7.83,0,1,0,7.9,7.75,7.83,7.83,0,0,0-7.9-7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M26.78,80a3.92,3.92,0,1,0,3.95,3.87A3.92,3.92,0,0,0,26.78,80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M104.49,74.52l.28,28.15a38.76,38.76,0,1,1-77.52.78L26.9,68.18c8.54-7.49,15.32-19.43,15.22-31.73a38.82,38.82,0,0,0,39.39,38.3l23-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M35.87,71.83A2.43,2.43,0,0,1,36.68,69a15.88,15.88,0,0,1,9.52-2.88,17.54,17.54,0,0,1,10,3,1.93,1.93,0,0,1,.34,2.86h0a2,2,0,0,1-2.58.32,13.77,13.77,0,0,0-15.37.15A2,2,0,0,1,36,72.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M109.16,90.89a3.92,3.92,0,1,1-3.87,4,3.91,3.91,0,0,1,3.87-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M23,91.75a3.91,3.91,0,1,1-3.87,4,3.91,3.91,0,0,1,3.87-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.17,86.65a1.77,1.77,0,0,1-2-2.93,12.42,12.42,0,0,1,13.73-.18,1.77,1.77,0,0,1-1.92,3,8.86,8.86,0,0,0-9.82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M81.52,86.14a1.77,1.77,0,1,1-2-2.93A12.4,12.4,0,0,1,93.25,83a1.77,1.77,0,1,1-1.91,3,8.86,8.86,0,0,0-9.82.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M71.5,97.84l-.08-8.7a2.17,2.17,0,1,0-4.33,0h0l.06,6.52-2.19,0a6.53,6.53,0,1,0,.12,13.06l4.35,0a2.17,2.17,0,0,0,2.15-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M407.7,19.8S456.4,41.39,456.4,68a47.86,47.86,0,0,0,21.1,40,48.34,48.34,0,0,1-45.59,32.23H407.7V19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M406.67,140.34h-24a48.22,48.22,0,0,1-45.47-32.27A48.14,48.14,0,0,0,358.53,68a48.05,48.05,0,0,1,48.14-48.2V140.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 406.38,
    cy: 58.14,
    rx: 44.2,
    ry: 31.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M451.24,56.5l.22,39.73a11.58,11.58,0,0,1-.6,4A79.45,79.45,0,0,1,430.77,131a85.1,85.1,0,0,1-16.43,12.19c-3.14,1.8-6,3-9.81,2.8-3.56-.2-6.33-1.84-9.23-3.58a84,84,0,0,1-24.93-22.77,26.61,26.61,0,0,1-3.12-5.48,69.32,69.32,0,0,1-4.3-11.78,11.59,11.59,0,0,1-.56-2.7V55.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M411.83,127c3.91,0,6.56-6.23,6.56-11l-12.72,1.64L393,115.9a12.45,12.45,0,0,0,6.55,11h12.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M451.61,66.2c0-15.45-21.34-25.16-44.39-25.3-19-.12-44.35,9.85-44.35,25.3h-4.25a48.78,48.78,0,0,1,48.61-48.85h0a49,49,0,0,1,49,48.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M408.67,91.5,408.29,84a1.87,1.87,0,0,0-3.74.19h0l.29,5.63-1.89.1a5.63,5.63,0,0,0,.57,11.25l3.75-.2a1.87,1.87,0,0,0,1.78-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M449,78.17a9,9,0,1,0,7.72,10.06A9,9,0,0,0,449,78.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M448.43,82.61a4.49,4.49,0,1,0,3.86,5,4.49,4.49,0,0,0-3.86-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M364.93,78.17a9,9,0,1,0,7.72,10.06,9,9,0,0,0-7.72-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M364.34,82.23a4.48,4.48,0,1,0,3.86,5,4.48,4.48,0,0,0-3.86-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M381.69,72.38c-.79,0-1.43-.24-1.43-1s.64-1,1.43-1h11.43c.79,0,1.43.24,1.43,1s-.64,1-1.43,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M417.41,72.38c-.79,0-1.43-.24-1.43-1s.64-1,1.43-1h11.43c.79,0,1.43.24,1.43,1s-.64,1-1.43,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M418.13,79.71a1.42,1.42,0,1,1-1.43-2.46,12.85,12.85,0,0,1,12.86,0,1.42,1.42,0,1,1-1.43,2.46,10,10,0,0,0-10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M382.4,79.71A1.42,1.42,0,1,1,381,77.25a12.85,12.85,0,0,1,12.86,0,1.42,1.42,0,1,1-1.42,2.46,10,10,0,0,0-10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M446.61,95.8s-7.76,12.27-9.58,13.35c-8,4.71-19.4-2.36-31.71-2.36-8.13,0-21.49,5.76-24.64,3.54A72.3,72.3,0,0,1,366,95.67l-5.53.26A65.52,65.52,0,0,0,369,117.6c8.31,13.47,26.51,28.4,36.73,28.4s30.55-18.28,37.41-29.43A127,127,0,0,0,453.8,95.78Zm-39.95,35.91c-11,0-15.83-10.74-15.83-17.82,0,0,31.41-.24,31.41-.2C422.24,120.78,417.65,131.71,406.66,131.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 361.15,
    y: 53.86,
    width: 5.02,
    height: 41.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 446.61,
    y: 53.86,
    width: 5.02,
    height: 41.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M786.38,77a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M705.7,77a4,4,0,1,0,4,4,4,4,0,0,0-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M746,24.57a40.16,40.16,0,0,1,40,40.34v40.34c0,22.19-25.06,37.83-40,40.35-5.12-.52-40-18.16-40-40.35V64.91a40.17,40.17,0,0,1,40-40.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M723.15,80.81A1.41,1.41,0,0,1,723,78l11.28-.65a1.41,1.41,0,1,1,.16,2.82l-11.28.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M758.33,80.3a1.41,1.41,0,0,1,.1-2.82l11.29.37a1.42,1.42,0,0,1,1.37,1.46,1.41,1.41,0,0,1-1.46,1.36l-11.3-.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 729.38,
    cy: 85.99,
    r: 3.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 763.18,
    cy: 85.99,
    r: 3.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M789.35,77.64c-5.82,1.64-6,15.66-5.63,8.18S767.55,75.54,774.51,69s.76-22.34,5.26-24.08C785.22,42.81,792,71.33,789.35,77.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M704.21,75.77c5.83,1.64,6,15.66,5.64,8.18S726,73.67,719.06,67.12,718.3,44.78,713.8,43C708.35,40.94,701.58,69.46,704.21,75.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M711.5,78.21c-.46,1.67-2.13,7.9-.46,11.25s4.11,9.58,11.25,10.18,11.71-1.06,14-4.1,4.56-6.24,3.19-11.4-2.58-5.17-6.08-6.39S711.5,78.21,711.5,78.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M754.07,78.21c-.46,1.67-2.13,7.9-.46,11.25s4.11,9.58,11.25,10.18,11.71-1.06,14-4.1,4.56-6.24,3.2-11.4S779.46,79,776,77.75,754.07,78.21,754.07,78.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M747.94,79.84s-6.51,2.82-6.51,6.3a15.75,15.75,0,1,1-31.49,0v.68h-6.3A2.24,2.24,0,0,1,701.38,85a2.06,2.06,0,0,1,2-2.3l6,.1V83a7.43,7.43,0,0,1,7.62-6.87h13.64a10.71,10.71,0,0,1,8.61,4,10.2,10.2,0,0,1,8.62-4.45v4.21Zm-16.26-1.71H718.76a6.88,6.88,0,0,0-6.82,7h0c0,6.88,4.79,13.06,11.61,14a13.67,13.67,0,0,0,15.63-13.57,7.53,7.53,0,0,0-7.48-7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M745.94,79.9V75.7a10,10,0,0,1,8.55,4.42,10.56,10.56,0,0,1,8.53-4h13.65a7,7,0,0,1,7.27,6.9v-.11l6.22-.16A2.14,2.14,0,0,1,792.33,85a2.17,2.17,0,0,1-2.2,1.87l-6.19,0V86.2a15.79,15.79,0,0,1-31.58,0,6.09,6.09,0,0,0-6.42-6.3Zm16.11-1.77a7.55,7.55,0,0,0-7.46,7.53,13.71,13.71,0,0,0,15.67,13.57c6.82-1,11.68-7.12,11.68-14v-.06a7,7,0,0,0-7-7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "754.84 80.44 738.5 80.18 728.27 75.57 763.98 75.75 754.84 80.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M750.74,101l-.47-9.33a2.33,2.33,0,1,0-4.65.23h0l.36,7-1.52.12c-3.85.2-6,3.5-5.82,7.36s1.83,6.84,5.7,6.64l4.67-.25a2.31,2.31,0,0,0,2.2-2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M937.59,74.94a8.12,8.12,0,1,0,8.12,8.12,8.12,8.12,0,0,0-8.12-8.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M937.59,79a4.06,4.06,0,1,0,4.06,4.06A4.06,4.06,0,0,0,937.59,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M848.29,83.06a8.12,8.12,0,1,0,8.12-8.12h0a8.11,8.11,0,0,0-8.12,8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M856.41,79a4.06,4.06,0,1,0,4.06,4.06A4.06,4.06,0,0,0,856.41,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M898.06,26.23a40.38,40.38,0,0,1,40.21,40.59v40.59a40.21,40.21,0,1,1-80.42,0V66.82a40.39,40.39,0,0,1,40.21-40.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M897,48.54H876.91c-2.24,0-4.16-.24-5.74-1.82l-5.74-5.84a4,4,0,0,1,0-5.68A44.49,44.49,0,0,1,897,22.15l8.11,13.19L897,48.54ZM864.53,69.39a2.21,2.21,0,0,0,2-2.24,2.11,2.11,0,0,0-2-2.13l-8.12,0a2.22,2.22,0,0,0,0,4.42Zm.58-8.91a2,2,0,0,0,2.48-1.43,2,2,0,0,0-1.43-2.48l-7.84-2.1a2,2,0,0,0-1.05,3.91l7.84,2.1Zm2.76-8a2,2,0,1,0,2-3.5l-7-4.06a2,2,0,0,0-2,3.5l7,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M887.29,73.59a2,2,0,1,1-3,2.7,10.16,10.16,0,0,0-15.13,0,2,2,0,0,1-3-2.7,14.19,14.19,0,0,1,21.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M927.88,73.59a2,2,0,0,1-3,2.7,10.17,10.17,0,0,0-15.14,0,2,2,0,1,1-3-2.7,14.19,14.19,0,0,1,21.17,0ZM896.57,48.54V22.17a44.21,44.21,0,0,1,31.78,13.08,4.05,4.05,0,0,1,.11,5.74l-5.69,5.73c-1.58,1.58-3.44,1.82-5.68,1.82Zm32.9,16.38a2.25,2.25,0,0,0,0,4.47h8.12a2.22,2.22,0,0,0,2-2.24,2.12,2.12,0,0,0-2-2.13l-8.12-.1Zm-1.63-8.35a2,2,0,1,0,1,3.91l7.83-2.1a2,2,0,1,0-1-3.91l-7.84,2.1ZM924.11,49a2,2,0,0,0,2,3.5l7-4.06a2,2,0,1,0-2-3.5l-7,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M876.7,79a4.06,4.06,0,1,1-4.06,4.06A4.06,4.06,0,0,1,876.7,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M917.3,79a4.06,4.06,0,1,1-4.06,4.06A4,4,0,0,1,917.3,79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M913.24,78.32c-3.35,0-6.1,2.07-6.1,5.42a10.81,10.81,0,0,0,11.1,10.81,11.39,11.39,0,0,0,11.09-11.49V78.32ZM897,77l-2-2,2-2a9.88,9.88,0,0,1,8.12,3.79,10.42,10.42,0,0,1,8.12-4.33h26.38a2.27,2.27,0,0,1,2,2.29c0,1.12-1.52,2.16-2.63,2.16l-6.7.14v6.1c0,8.4-6.2,15.22-14.61,15.22a15,15,0,0,1-14.92-15.22A5.84,5.84,0,0,0,897,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M896.57,77s-5.87,2.73-5.87,6.09a14.94,14.94,0,1,1-29.87,0V77h-6.27a2.35,2.35,0,0,1-2.11-2.3,2.19,2.19,0,0,1,1.93-2.29h26.38a10,10,0,0,1,7.9,4.33,9.79,9.79,0,0,1,7.91-3.79V77Zm-15.81,1.35h-17v4.74a11.48,11.48,0,0,0,11.52,11.16c6.16,0,11.34-4.32,11.34-10.48,0-3.35-2.56-5.42-5.91-5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M900.63,94.26l-.28-10.16a2.53,2.53,0,0,0-5.06.14h0l.21,7.62-2.55.08a7.62,7.62,0,1,0,.42,15.24l5.08-.15a2.53,2.53,0,0,0,2.46-2.6Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeads);
export default __webpack_public_path__ + "static/media/character-heads.6338c2a8b97292229893702dd3552ee2.svg";
export { ForwardRef as ReactComponent };